<template>
  <div ref="chartContainer" class="chart-container"></div>
</template>

<script setup>
import { ref, onMounted, onUnmounted, watch } from "vue";
import { createChart } from "lightweight-charts";

const props = defineProps({
  series: {
    type: Array,
    required: true,
  },
});

const chartContainer = ref(null);
let chart = null;
let lineSeries = null;

function initChart() {
  const w = chartContainer.value?.clientWidth || 600;
  const h = chartContainer.value?.clientHeight || 400;

  chart = createChart(chartContainer.value, {
    width: w,
    height: h,
    layout: {
      background: { color: "#0b0e11" },
      textColor: "#d1d4dc",
    },
    grid: {
      vertLines: { color: "#1e222d" },
      horzLines: { color: "#1e222d" },
    },
    rightPriceScale: { borderColor: "#1e222d" },
    timeScale: {
      borderColor: "#1e222d",
      timeVisible: true,
      secondsVisible: false,
    },
    crosshair: { mode: 1 },
  });

  lineSeries = chart.addLineSeries({ lineWidth: 2 });

  if (props.series?.length) {
    lineSeries.setData(props.series);
    chart.timeScale().fitContent();
  }

  // ✅ ensure it matches container after mount
  resizeChart();
}


onMounted(() => {
  initChart();
  window.addEventListener("resize", resizeChart);
});

onUnmounted(() => {
  if (chart) chart.remove();
  window.removeEventListener("resize", resizeChart);
});

function resizeChart() {
  if (!chart || !chartContainer.value) return;
  chart.applyOptions({
    width: chartContainer.value.clientWidth,
    height: chartContainer.value.clientHeight,
  });
}

watch(
    () => props.series,
    (newSeries) => {
      if (lineSeries && Array.isArray(newSeries)) {
        lineSeries.setData(newSeries);
        chart.timeScale().fitContent();
      }
    },
    { deep: true }
);
</script>

<style scoped>
.chart-container {
  width: 100%;
  height: 400px;
}
</style>
